import { useState } from "react";
import { useModal } from "context";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FormButton } from "reusableComponents";
import { deleteBooking } from "services/booking.services";

import styles from "./styles.module.scss";

const DeleteCardConfirmationModal = ({ handleDelete }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation("global");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const accessToken = useSelector((state) => state.auth.token);



  return (
    <div
      className={`${styles.deleteCardConfirmationModal} ${
        loading ? styles.loading : ""
      }`}
    >
      <p>{t("dashboard.cards.confirmationText")}</p>
      {error && <p className={styles.error}>{error}</p>}
      <div className={styles.buttons}>
        <FormButton
          variant="reset"
          onClick={closeModal}
          label={t("buttons.cancel")}
        />
        <FormButton
          variant="submit"
          onClick={handleDelete}
          disabled={loading}
          label={t("buttons.confirm")}
        />
      </div>
    </div>
  );
};

export default DeleteCardConfirmationModal;
